module.exports = __webpack_public_path__ + "static/img/cocina_11.b599bbc6.jpeg";